import _ from "lodash";
import moment from "moment-timezone";

const weekdayAbbreviations = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export function getWeekdayAbbr(date) {
  return weekdayAbbreviations[new Date(date).getDay()];
}

export function isWeekend(date) {
  const wd = new Date(date).getDay();
  return wd === 0 || wd === 6;
}

export function parseDuration(ms, decimals = 0) {
  const seconds = Math.round(ms / 1000);
  const days = seconds / 86400;
  if (days > 1) {
    return `${_.toNumber(days.toFixed(decimals))}d`;
  }
  const hours = seconds / 3600;
  if (hours > 1) {
    return `${_.toNumber(hours.toFixed(decimals))}h`;
  }
  const minutes = seconds / 60;
  if (minutes > 1) {
    return `${_.toNumber(minutes.toFixed(decimals))}m`;
  }
  return `${seconds}s`;
}

export function getDateList(start, end, includeEnd = false) {
  const startDate = moment(start);
  const endDate = moment(end);
  const dateList = [];

  for (
    let m = startDate;
    includeEnd ? m.isSameOrBefore(endDate) : m.isBefore(endDate);
    m.add(1, "days")
  ) {
    dateList.push(m.format("YYYY-MM-DD"));
  }

  return dateList;
}
